import React from "react";
import { HOW } from "@/constants/testIds";
import { Plug, Cpu, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: Plug,
    title: "Connect your EHR & clearinghouse",
    body:
      "Native integrations and SFTP feeds pull eligibility, sessions and 837/835 data in minutes — not weeks.",
  },
  {
    icon: Cpu,
    title: "AI agents work every claim",
    body:
      "Zaplee.ai scrubs, submits, posts payments, flags underpayments and routes denials with payer-specific playbooks.",
  },
  {
    icon: TrendingUp,
    title: "Watch collections grow",
    body:
      "Track every dollar across the lifecycle. Surface root causes, reduce A/R days, and give finance a single source of truth.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid={HOW.section}
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="font-mono-label text-[10px] text-[#0047FF]">
            // How it works
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-semibold tracking-tighter text-zinc-950">
            From sign-up to faster collections in three steps.
          </h2>
        </div>

        <div className="relative mt-14">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-9 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-zinc-300 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  className="relative rounded-2xl border border-zinc-200 bg-white p-7"
                >
                  <div className="flex items-center justify-between">
                    <div className="h-[72px] w-[72px] rounded-2xl bg-zinc-950 text-white grid place-items-center shadow-lg">
                      <Icon size={26} />
                    </div>
                    <span className="font-display text-[64px] leading-none font-semibold text-zinc-100">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-display mt-6 text-xl font-semibold tracking-tight text-zinc-950">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-zinc-600 leading-relaxed">
                    {s.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
